import { SaleSidebarTabs, SaleTabKey } from '@/pages/sale/components/sale-sidebar-tabs';
import { useSaleSidebarData } from '@/pages/sale/context/sale-product-context';
import { FBLive, FBPost } from '@/types/fb-type';
import Grid from '@mui/material/Grid';
import { memo } from 'react';

type SaleSidebarColumnProps = {
  activeTab: SaleTabKey;
  onTabChange: (tabKey: SaleTabKey) => void;
  conversations: Parameters<typeof SaleSidebarTabs>[0]['conversations'];
  loadingConversations: boolean;
  onConversationSelect: Parameters<typeof SaleSidebarTabs>[0]['onConversationSelect'];
  onPostSelect: (post: FBPost | FBLive) => void;
  onSelectQueueCustomer: Parameters<typeof SaleSidebarTabs>[0]['onSelectQueueCustomer'];
  onDropProductOnQueueCustomer: Parameters<typeof SaleSidebarTabs>[0]['onDropProductOnQueueCustomer'];
  autoDetectChat: boolean;
  handleUpdateAutoDetectChat: Parameters<typeof SaleSidebarTabs>[0]['handleUpdateAutoDetectChat'];
  autoDetectComment: boolean;
  handleUpdateAutoDetectComment: Parameters<typeof SaleSidebarTabs>[0]['handleUpdateAutoDetectComment'];
  refetchConversation: () => Promise<void>;
};

export const SaleSidebarColumn = memo(function SaleSidebarColumn({
  activeTab,
  onTabChange,
  conversations,
  loadingConversations,
  onConversationSelect,
  onPostSelect,
  onSelectQueueCustomer,
  onDropProductOnQueueCustomer,
  autoDetectChat,
  handleUpdateAutoDetectChat,
  autoDetectComment,
  handleUpdateAutoDetectComment,
  refetchConversation,
}: SaleSidebarColumnProps) {
  const {
    posts,
    isLoadingPost,
    fbLives,
    loadingFbLives,
    autoReplies,
    qCustomers,
  } = useSaleSidebarData();

  return (
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        height: { xs: 'auto', md: '100%' },
        minHeight: { xs: '400px', md: 0 },
        width: { xs: '100%', md: '33.333333%' },
        maxWidth: { xs: '100%', md: '33.333333%' },
        paddingLeft: { xs: '8px !important', md: '16px !important' },
        paddingTop: { xs: '8px !important', md: '16px !important' },
      }}
    >
      <SaleSidebarTabs
        activeTab={activeTab as 'live' | 'inbox' | 'post' | 'auto' | 'waiting'}
        onTabChange={onTabChange}
        conversations={conversations}
        loadingConversations={loadingConversations}
        onConversationSelect={onConversationSelect}
        posts={posts}
        isLoadingPost={isLoadingPost}
        onPostSelect={onPostSelect as (post: FBPost) => void}
        autoReplies={autoReplies}
        queueCustomers={qCustomers}
        onSelectQueueCustomer={onSelectQueueCustomer}
        onDropProductOnQueueCustomer={onDropProductOnQueueCustomer}
        fbLives={fbLives}
        onSelectLiveVideo={(fbLive) => {
          if (fbLive) {
            onPostSelect(fbLive);
          }
        }}
        loadingFbLives={loadingFbLives}
        autoDetectChat={autoDetectChat}
        handleUpdateAutoDetectChat={handleUpdateAutoDetectChat}
        autoDetectComment={autoDetectComment}
        handleUpdateAutoDetectComment={handleUpdateAutoDetectComment}
        refetchConversation={refetchConversation}
      />
    </Grid>
  );
});
